import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import React from 'react';
// using inline styles as figma is done with new dls which cant be used here 
// these can be reused in new revamp
const ElevateContinueCard = ({ onPress, action, triggerAction }) => {
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, { style: {
            backgroundColor: "#FFFFFF",
            borderRadius: 16,
            flexDirection: 'row',
            overflow: 'hidden'
        } },
        React.createElement(View, { style: { flex: 1, paddingHorizontal: 16, paddingVertical: 24 } },
            React.createElement(Image, { style: { height: 18, width: 90, marginBottom: 16 }, resizeMode: 'contain', source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_logo.png" } }),
            React.createElement(Text, { style: { color: "#152130", fontSize: 20, fontWeight: "600", lineHeight: 28, marginRight: 40 } }, "Complete loan application journey"),
            React.createElement(Text, { style: { color: "#60646C", fontSize: 12, fontWeight: "400", lineHeight: 18, marginTop: 8 } }, "You\u2019re almost there, just a few more steps to go."),
            React.createElement(Pressable, { onPress: handleAction, style: { marginTop: 20, alignItems: "center", borderWidth: 1, borderColor: "#1434CB", borderRadius: 40, height: 40, justifyContent: "center" } },
                React.createElement(Text, { style: { color: "#1434CB", fontSize: 14, fontWeight: "700", lineHeight: 22 } }, "Continue"))),
        React.createElement(Image, { style: { height: 119, width: 160, alignSelf: "flex-end", position: 'absolute', right: 0, top: 0 }, source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_round_bg.png" } })));
};
export default ElevateContinueCard;
// Todo: Use new theme while revamping
const styles = StyleSheet.create({
    card: {
        backgroundColor: '#1434cb',
        borderRadius: 16,
        flexDirection: 'row',
        overflow: 'hidden',
    },
    textContainer: {
        flex: 1,
        paddingLeft: 12,
        paddingVertical: 16,
        paddingBottom: 24,
    },
    title: {
        color: 'white',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 24,
    },
    subtitle: {
        color: '#E4E7EC',
        marginTop: 8,
        fontSize: 12,
        lineHeight: 18,
    },
    coinImage: {
        height: 95,
        width: 95,
        alignSelf: 'flex-end',
    },
    bgImage: {
        height: '100%',
        width: 120,
        alignSelf: 'flex-end',
        position: 'absolute',
        right: 0,
    },
});
